import React from 'react';
import { Link } from 'react-router-dom';

const Logo = () => {
    return (
        <div className="logo-container mobile:w-44 relative w-52">
            <Link to="/">
                <img src="https://files.hasbaratracker.com/ht-logo-with-slogan.svg" alt="Hasbara Tracker - Tracking Israeli propaganda"></img>
            </Link>
        </div>
    );
}

export default Logo;
